export function getDefaultContextMenuForGrid(params) {
	return [
		'copy',
		'copyWithHeaders',
		'separator',
		'export',
		'separator',
		{
			name: 'Označit vše',
			icon: '<i class="fa fa-star"/>',
			action: function () {
				params.api.selectAllFiltered();
			},
		},
		{
			name: 'Zrušit označení',
			icon: '<i class="fa fa-star-o"/>',
			action: function () {
				params.api.deselectAll();
			},
		},
		'separator',
		{
			name: 'Zrušit filtr',
			icon: '<i class="fa fa-remove"/>',
			action: function () {
				params.api.setFilterModel(null);
			},
		},
	];
}

export function createMassChangeMenu(items, baseUri, params) {
  var massChangeSubmenu = [];
  _.forEach(items, function (item) {
    massChangeSubmenu.push({
      name: item.name,
      action: function () {
        let listId = getSelectedRowIds(params.api, params.node.id);
        sessionStorage.setItem(baseUri + '#' + item.massChangeType, listId.join(','))
        openInModalDialog(baseUri + '?type=' + item.massChangeType, '1000px');
      },
    });
  });

  return [
    {
      name: 'Hromadná změna',
      icon: '<i class="fa fa-th-list"/>',
      subMenu: massChangeSubmenu,
    },
    'separator',
  ];
}

window.createMassChangeMenu = createMassChangeMenu;
window.getDefaultContextMenuForGrid = getDefaultContextMenuForGrid;